import { render, staticRenderFns } from "./assinaturas.vue?vue&type=template&id=692e054a&scoped=true"
import script from "./assinaturas.vue?vue&type=script&lang=js"
export * from "./assinaturas.vue?vue&type=script&lang=js"
import style0 from "./assinaturas.vue?vue&type=style&index=0&id=692e054a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692e054a",
  null
  
)

export default component.exports